<template>
    <span
        class="error-span"
        role="alert"
        v-if="is_active"
        v-text="message"
    ></span>
</template>

<script>
    export default {
        props: {
            error: {
                required: true
            },
        },

        computed: {
            is_active() {
                return this.error
            },

            message() {
                return this.error
            }
        }
    }
</script>
